import { CreateAccountStep } from "@affinity/Store/StoreTypes";
import { BillToModel, ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

export type CreateAccountState = Readonly<{
    currentStep: CreateAccountStep;
    firstName: string | undefined;
    lastName: string | undefined;
    contactNumber: string | undefined;
    emailAddress: string | undefined;
    // password: string | undefined; // REVIEW SECURITY OPTIONS - COULD PUSH TO DB AND RECOVER LATER / MAKE UNDEFINED
    existingAddresses: ShipToCollectionModel | undefined;
    selectedAddress: ShipToModel | undefined;
    confirmedMarketing: boolean;
    confirmedTermsAndConditions: boolean;
    targetUrl: string | undefined;
    billTo: BillToModel | undefined;
    isAddingAddress: boolean;
}>;

export const initialState: CreateAccountState = {
    currentStep: CreateAccountStep.First,
    firstName: undefined,
    lastName: undefined,
    contactNumber: undefined,
    emailAddress: undefined,
    // password: undefined, // REVIEW SECURITY OPTIONS - COULD PUSH TO DB AND RECOVER LATER / MAKE UNDEFINED
    existingAddresses: undefined,
    selectedAddress: undefined,
    confirmedMarketing: false,
    confirmedTermsAndConditions: false,
    targetUrl: undefined,
    billTo: undefined,
    isAddingAddress: true,
}

export default CreateAccountState;